import {
  QueryClient,
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

import { RequestErrorType } from '@core/utils/api-axios-instance'
import { IBriefingSession } from '@core/entities/briefing'
import { briefingKeys, RequestTypes } from '@core/react-query/features/briefing'
import { optimisticallyHandleBriefingSession } from '@core/react-query/features/briefing/helpers'

export const getUpdateBriefingSessionMutationOptions = (
  queryClient: QueryClient,
  options: Parameters<typeof useUpdateBriefingSession>[0] = {},
): Parameters<typeof useUpdateBriefingSession>[0] => {
  return {
    ...(options ?? {}),
    ...briefingKeys.updateBriefingSession,
    onSuccess: (...args) => {
      const [data] = args

      optimisticallyHandleBriefingSession(queryClient, data)
      options?.onSuccess?.(...args)
    },
  }
}

export const useUpdateBriefingSession = (
  options: UseMutationOptions<
    IBriefingSession,
    RequestErrorType,
    RequestTypes['updateBriefingSession']
  > = {},
) => {
  const queryClient = useQueryClient()

  return useMutation(
    getUpdateBriefingSessionMutationOptions(queryClient, options),
  )
}
